var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._b(
      {
        attrs: {
          "popper-append-to-body": false,
          "popper-class": "t-select-popper",
          filterable: "",
        },
        model: {
          value: _vm.changeValue,
          callback: function ($$v) {
            _vm.changeValue = $$v
          },
          expression: "changeValue",
        },
      },
      "el-select",
      Object.assign({}, _vm.item),
      false
    ),
    _vm._l(_vm.getOptions(), function (option, index) {
      return _c("el-option", {
        key: option.value + index,
        attrs: { value: option.value, label: option.label },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }